import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';

import {
  catalogBibShape,
  listShape,
  userIdentityShape,
  paginationShape,
  libraryShape
} from '@bibliocommons/bc-prop-types';
import { ChevronLink } from '@bibliocommons/base-links';
import Context from '@bibliocommons/context';

import Heading from 'app/components/shared/Heading';
import AddToListDropdown from 'app/components/bibs/shared/AddToListDropdown';
import ListCardAdapter from 'app/components/shared/ListCardAdapter';

import './CommunityLists.scss';

export default function CommunityLists({
  lists,
  pagination,
  catalogBib,
  users,
  library,
  trackAddToListClick,
  trackAddToNewListClick,
  trackListImageClick,
  trackListTitleClick
}) {
  const { mobileApp } = useContext(Context);

  function renderContent() {
    if (lists?.size > 0) {
      const metadataId = catalogBib.get('metadataId');
      const totalCount = pagination.get('count');

      return (
        <div className="community-lists-content">
          <ul>
            {lists.map(list => (
              <li key={list.get('id')}>
                <ListCardAdapter
                  creator={users.get(list.getIn(['owner', 'id']).toString())}
                  handleListImageClick={() => trackListImageClick(list.get('id'))}
                  handleListTitleClick={() => trackListTitleClick(list.get('id'), list.get('name'))}
                  horizontal
                  library={library}
                  list={list}
                  smallCreatorLink
                  smallHeading
                  titleTag="div"
                />
              </li>
            ))}
          </ul>
          {totalCount > lists.size && (
            <ChevronLink
              className="view-all-link"
              dataKey="view-all-community-lists"
              href={`/v2/record/${metadataId}/lists?category=COMMUNITY`}
            >
              <FormattedMessage id="view_all_community_lists" values={{ count: totalCount }} />
            </ChevronLink>
          )}
        </div>
      );
    }

    return (
      <div className="empty-community-lists">
        <FormattedMessage id="empty_community_lists" />
      </div>
    );
  }

  if (mobileApp && !lists?.size) return null;

  return (
    <div className="cp-community-lists">
      <div className="community-lists-heading">
        <Heading tagName="h3" size="medium" variant>
          <FormattedMessage id="community_lists_featuring_title" />
        </Heading>
      </div>
      <AddToListDropdown
        catalogBib={catalogBib}
        overlayKey="add-to-list-overlay-community-lists"
        trackAddToListClick={trackAddToListClick}
        trackAddToNewListClick={trackAddToNewListClick}
      />
      {renderContent()}
    </div>
  );
}

CommunityLists.propTypes = {
  library: libraryShape.isRequired,
  catalogBib: catalogBibShape.isRequired,
  pagination: paginationShape.isRequired,
  users: ImmutablePropTypes.mapOf(userIdentityShape),
  lists: ImmutablePropTypes.listOf(listShape).isRequired,
  trackAddToListClick: PropTypes.func.isRequired,
  trackAddToNewListClick: PropTypes.func.isRequired,
  trackListImageClick: PropTypes.func.isRequired,
  trackListTitleClick: PropTypes.func.isRequired
};
